import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPl = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h16v10H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#dc143c", d: "M0 5h16v5H0z" }));
const ForwardRef = forwardRef(SvgPl);
const Memo = memo(ForwardRef);
export default Memo;
